import GetTaskListRequestFilter from '../../../../../../projects/task/i-service/models/task/response/GetTaskListRequestFilter';
import GetTaskListRequestVisibleSettings from '../../../../../../projects/task/i-service/models/task/request/GetTaskListRequestVisibleSettings';
import GetTaskListRequestSort from '../../../../../../projects/task/i-service/models/task/request/GetTaskListRequestSort';
import PageRequest from '../../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса на получение списка задач по исполнителю
 */
export default class GetByPerformerTaskListRequest  {
	/**
	 * * Номер исполнителя
	 */
	PerformerId!: number;
	/**
	 * * Номер очереди задач
	 */
	QueueTaskId!: string;
	/**
	 * * Фильтр
	 */
	Filter!: GetTaskListRequestFilter;
	/**
	 * * Настройки видимости полей
	 */
	VisibleSettings!: GetTaskListRequestVisibleSettings;
	/**
	 * * Настройки сортировки
	 */
	Sort!: GetTaskListRequestSort;
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	constructor(obj?: Partial<GetByPerformerTaskListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
